import Axios from 'axios'

export interface IShareUniversal {
  shareUrl?: string
  actions: {
    createUrl?: string
    deactivateUrl?: string
  }
}

export function canAccess(shareable: IShareUniversal) {
  return !!shareable?.shareUrl || !!shareable?.actions?.createUrl
}

export async function getUniversalShareUrl(shareable: IShareUniversal) {
  if (!shareable.shareUrl && shareable.actions.createUrl) {
    await Axios.post<IShareUniversal>(shareable.actions.createUrl).then((response) => {
      shareable.shareUrl = response.data.shareUrl
      shareable.actions = response.data.actions
    })
  }

  return shareable.shareUrl
}

export async function deactivateUniversalShareUrl(shareable: IShareUniversal) {
  if (shareable.actions.deactivateUrl) {
    await Axios.put(shareable.actions.deactivateUrl).then(() => {
      shareable.shareUrl = null
      shareable.actions.deactivateUrl = null
    })

    return true
  }

  return false
}
